var map = {
	"./asset-hyperlink.json": 1094,
	"./blockquote.json": 1095,
	"./document.json": 1096,
	"./embedded-asset-block.json": 1097,
	"./embedded-entry-block.json": 1098,
	"./embedded-entry-inline.json": 1099,
	"./embedded-resource-block.json": 1100,
	"./embedded-resource-inline.json": 1101,
	"./entry-hyperlink.json": 1102,
	"./heading-1.json": 1103,
	"./heading-2.json": 1104,
	"./heading-3.json": 1105,
	"./heading-4.json": 1106,
	"./heading-5.json": 1107,
	"./heading-6.json": 1108,
	"./hr.json": 1109,
	"./hyperlink.json": 1110,
	"./list-item.json": 1111,
	"./ordered-list.json": 1112,
	"./paragraph.json": 1113,
	"./resource-hyperlink.json": 1114,
	"./table-cell.json": 1115,
	"./table-header-cell.json": 1116,
	"./table-row.json": 1117,
	"./table.json": 1118,
	"./text.json": 1119,
	"./unordered-list.json": 1120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1093;